module.exports = __webpack_public_path__ + "media/images/logos/schufa_logo-730023dedd348ab6d426768318c98a1f.svg";